import { gql } from 'graphql-tag';
import { EXPORT_RUN_FIELDS } from './fragments';

// The run's row once on subscribe and again whenever its status changes;
// the server ends the stream after COMPLETED or FAILED.
export const EXPORT_RUN_STATUS = gql`
  subscription ExportRunStatus($id: Int!) {
    exportRunStatus(id: $id) {
      ...ExportRunFields
    }
  }
  ${EXPORT_RUN_FIELDS}
`;
